<template>
  <v-container>
  <div v-if="tournament" class="resumen_tournament">
    <v-row>
      <v-col>
    <div class="pt-3"> {{tournament.title}} </div>
      </v-col>
    </v-row>
  <v-row>
    <v-col>
      <div>Fecha: {{tournament.start_date}}</div>
    </v-col>
  </v-row>

    <v-row>
    <v-col v-if="tournament.club">
      <div>Club: {{tournament.club.name}}</div>
    </v-col>
  </v-row>
  </div>
  <template v-if="tournament && category_selected">
  <v-row>
    <v-col offset="2" cols="8">

    <v-tabs
      v-model="category_selected"
      color="deep-purple-accent-4"
      align-tabs="center"
    >

      <v-tab v-for="cat in categories_created" :value="cat" :key="cat.id" color="red">{{ cat.name }}</v-tab>
    </v-tabs>
    </v-col>
  </v-row>
  <br><br>
    <v-window v-if="tournament" v-model="category_selected">
      <v-row v-if="is_authenticated">
        <v-col cols="2" offset-md="1">

        </v-col>
        <v-col cols="2">
          <v-select
              v-model="category_selected.type"
              :items="options"
              label="Selecciona Tipo Torneo"
            ></v-select>
        </v-col>
        <v-col cols="2">
          <v-text-field label="Categoria" v-model="category_selected.name"></v-text-field>
        </v-col>
        <v-col cols="2">

          <v-file-input label="Archivo torneo" @change="onFileChange($event)"></v-file-input>
          <v-btn @click="guardar" color="primary" class="mr-10">Guardar</v-btn>
          <v-btn v-if="category_selected.id" @click="eliminar" color="red">Eliminar</v-btn>
          <p v-if="download">Cargando...</p>
          <p v-for="error in errors" :key="error">{{error}}</p>
        </v-col>
      </v-row>
    </v-window>
  <v-row v-if="category_selected.id && category_selected.correct==false && is_authenticated">
    <v-col>
      <br><br>
      <div class="red-background text-center"> Hay participantes sin club, estos torneos no seran rankeados, si es una excepcion contatar al admin </div>
    </v-col>

  </v-row>
  <v-row v-if="category_selected.id">

    <v-col cols="10" offset="1">

      <v-table density="compact">
    <thead>
      <tr>
        <th class="text-center">

        </th>
        <th class="text-center">
          Nombre
        </th>
        <th class="text-center">
          ID
        </th>
        <th class="text-center">
          Puntos
        </th>
        <th class="text-center">
          ELO
        </th>
        <th class="text-center">
          Variacion
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="(item, index_l) in category_selected.participants.slice().sort((a, b) => b.points - a.points)"
        :key="item.id"
        :class="{ 'red-background': item.person.club_id == null && is_authenticated }"
      >
        <td class="text-center">{{ index_l + 1 }}</td>
        <td class="text-center"><a :href="'/resultados_jugador_torneo/'+item.id" style="color:blue">{{ item.person.full_name }}</a></td>
        <td class="text-center">{{ item.person.federation_id }}</td>
        <td class="text-center">{{ item.points }}</td>
        <td class="text-center">
          {{ item.elo_participant }}
        </td>
        <td class="text-center">
          {{ roundNumberToDecimal(item.diff_elo) }}
        </td>
      </tr>
    </tbody>
  </v-table>

    </v-col>
  </v-row>
  <v-row v-if="category_selected.id">
    <v-col offset="2" cols="8">

    <v-tabs
      v-model="round_selected"
      color="deep-purple-accent-4"
      align-tabs="center"
    >
      <v-tab v-for="round in category_selected.rounds" :value="round" :key="round.id" color="red">Ronda {{ round.round_number }}</v-tab>
    </v-tabs>
    </v-col>
  </v-row>
  <v-row v-if="category_selected.id && round_selected">

    <v-col offset="1" cols="10">
      <h1 class="text-center">Ronda {{round_selected.round_number}}</h1>
      <v-table density="compact">
    <thead>
      <tr>
        <th class="text-center">
          Blancas
        </th>
        <th class="text-center">
          Diff
        </th>
        <th class="text-center">
          Negras
        </th>
        <th class="text-center">
          Diff
        </th>
        <th class="text-center">
          Resultado
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="item in round_selected.games"
        :key="item.id"
      >
        <td class="text-center">{{ item.white_entity.first_name }} {{ item.white_entity.last_name }}</td>
        <td class="text-center">{{ roundNumberToDecimal(item.white_diff) }}</td>
        <td class="text-center" v-if="item.black_entity">{{ item.black_entity.first_name }} {{ item.black_entity.last_name }}</td>
        <td class="text-center" v-else>No emparejado</td>
        <td class="text-center">{{ roundNumberToDecimal(item.black_diff) }}</td>
        <td class="text-center">
          <p v-if="item.result=='W'"> 1-0</p>
          <p v-else-if="item.result=='B'"> 0-1</p>
          <p v-else-if="item.result=='D'"> 0.5-0.5</p>
          <p v-else-if="item.result=='H'"> + -</p>
          <p v-else-if="item.result=='L'"> - +</p>
          <p v-else> </p>
        </td>
      </tr>
    </tbody>
  </v-table>

    </v-col>
  </v-row>
</template>
  </v-container>
</template>
<script>
import axios from 'axios';
import gql from "graphql-tag";
import {mapState} from "vuex";
export default {
  props:["id"],
  apollo: {
    tournament: {query: gql` query($id:String!){
       tournament(id:$id){
        id
        title
        start_date:startDateFormated
        factor
        categorytournamentSet{
          id
          name
          type
          correct
          participants:tournamentparticipantSet{
            id
            person {
              id
              full_name:fullName
              federation_id:federationId
              club_id:clubId
            }
            points
            elo_participant:eloParticipant
            diff_elo:diffElo
          }
          rounds:roundSet{
            round_number:roundNumber
            games: gameSet{
              result
              white_diff:whiteDiff
              black_diff:blackDiff
              white_entity:whiteEntity{
                first_name:firstName
                last_name:lastName
              }
              black_entity:blackEntity{
                first_name:firstName
                last_name:lastName
              }
            }
          }
        }
      }
    }`,
      variables() {return {"id" :this.id}}
    },
  },
  name:"SeeTournamentResult",
  data() {
    return {
      categories_created:[],
      category_selected:null,
      tournament:null,
      tournament_type:"Suizo",
      tournament_name:"",
      file: null,
      errors:[],
      download:false,
      options: ["Suizo","Equipos", "Round Robin"],
      round_selected:null,
    }
  },
  computed: {
    ...mapState(['is_authenticated']),
  },
  methods: {
    roundNumberToDecimal(number) {
      if(!number){
        return number
      }
      return parseFloat((1*number)*(1*this.tournament.factor)).toFixed(1); // Redondear a un decimal
    },
    guardar(){
      if(this.download){
        return true
      }
      if(this.category_selected.name == ""){
        alert("ingrese nombre")
        return
      }
      const data = {
        tournament_id : this.id,
        tournament_type : this.category_selected.type,
        tournament_name : this.category_selected.name,
        category_id : this.category_selected.id
      }
      const formData = new FormData();
      formData.append(`file`, this.file );
      formData.append('data', JSON.stringify(data));
      const config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      };

      const self = this
      this.download = true
      axios.post('/load_tournament/',formData,config)
      .then((res) => {
        self.download = false
        if(res.data.success){
          window.location.href = "/resultados_torneo/"+this.id
        } else {
          self.errors = res.data.messages
        }

      })
      .catch(error => {
        alert("error avisar a administracion")
        console.error(error)
      })
    },
    eliminar(){
      if(this.download){
        return true
      }
      if(!confirm("Estas seguro quieres eliminar")){
        return
      }
      const data = {
        tournament_id : this.id,
        tournament_type : this.category_selected.type,
        tournament_name : this.category_selected.name,
        category_id : this.category_selected.id
      }
      const formData = new FormData();
      formData.append(`file`, this.file );
      formData.append('data', JSON.stringify(data));
      const config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      };

      const self = this
      this.download = true
      axios.post('/delete_category/',formData,config)
      .then((res) => {
        self.download = false
        if(res.data.success){
          window.location.href = "/resultados_torneo/"+this.id
        } else {
          self.errors = res.data.messages
        }

      })
      .catch(error => {
        alert("error avisar a administracion, recuerde si fue rankeado no puede ser borrado")
        console.error(error)
      })
    },
    onChange() {
      console.log("this.content",this.content)
    },
    uploadCallback(url) {
      console.log('uploaded url', url)
    },
    onFileChange(event){
      this.file = event.target.files[0];
    },
  },
  watch:{
    '$apollo.loading'(val){
      console.log(val)
      if(!val){
        if(this.is_authenticated){
          let c_origimal = {name:'Nueva Categoria',id:null, type:"Suizo"}
            this.categories_created.push(c_origimal)
          this.category_selected = c_origimal
          }
        for(let c in this.tournament.categorytournamentSet){
          let c_ob = JSON.parse(JSON.stringify(this.tournament.categorytournamentSet[c]))
          this.categories_created.push(c_ob)
          if(!this.is_authenticated && !this.category_selected){
            this.category_selected = c_ob
          }
          console.log(c_ob)
        }
      }
    },
    'category_selected'(val){
      if(val.id){
        this.round_selected = val.rounds[0]
      }
    }
  },

}
</script>
<style>
.resumen_tournament{
  font-family: Montserrat;
font-size: 30px;
font-weight: 600;
line-height: 37px;
letter-spacing: 0em;
text-align: left;
color: #F4F4F4;
  background-color:#2A4558;
  text-align: center;

}

.red-background {
  background-color: coral;
}
@media (max-width: 600px) {
  .resumen_tournament{
    font-size: 24px;
  }
}
</style>
